import { Component, effect, Input, OnChanges } from '@angular/core';
import { NgxEchartsDirective } from 'ngx-echarts';
import { EChartsOption } from 'echarts';
import { DASHBOARD_CHART_PALETTES, ECHARTS_THEMES } from '../../../../shared/services/echarts/echarts.config';
import { ThemeService } from '../../../../shared/services/theme/theme.service';

@Component({
  selector: 'l-dashboard-progress-bar',
  standalone: true,
  imports: [NgxEchartsDirective],
  templateUrl: './dashboard-progress-bar.component.html',
})
export class DashboardProgressBarComponent implements OnChanges {

  constructor(private readonly themeService: ThemeService) {
    effect(() => {
      this.themeService.theme();

      if (this.value !== undefined) {
        this.chartOptions = this.buildOptions();
      }
    });
  }

  @Input({ required: true })
  public value!: number;

  @Input()
  public maxValue = 100;

  @Input()
  public barColor = '#4a3aff';

  /**
   * Cor da trilha; quando não informada, usa a trilha do tema atual
   */
  @Input()
  public trackColor?: string;

  @Input()
  public heightClass = 'h-3.5';

  public chartOptions: EChartsOption = {};

  public readonly theme = ECHARTS_THEMES[this.themeService.theme()];

  public ngOnChanges(): void {
    this.chartOptions = this.buildOptions();
  }

  private buildOptions(): EChartsOption {
    const safeMax = this.maxValue > 0 ? this.maxValue : 100;
    const clamped = Math.max(0, Math.min(this.value, safeMax));

    return {
      animationDuration: 500,
      grid: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        containLabel: false,
      },
      xAxis: {
        type: 'value',
        min: 0,
        max: safeMax,
        show: false,
      },
      yAxis: {
        type: 'category',
        data: [''],
        show: false,
      },
      series: [
        {
          type: 'bar',
          data: [clamped],
          barWidth: '100%',
          showBackground: true,
          backgroundStyle: {
            color: this.trackColor ?? DASHBOARD_CHART_PALETTES[this.themeService.theme()].progressTrack,
            borderRadius: 999,
          },
          itemStyle: {
            color: this.barColor,
            borderRadius: 999,
          },
          emphasis: {
            disabled: true,
          },
        },
      ],
      tooltip: { show: false },
    };
  }

}
